import React from "react";
import "./App.css";
import { Link, Redirect } from "react-router-dom";
import Axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import { v4 as uuidv4 } from "uuid";
import {
  BsFileArrowDown,
  BsShield,
  BsShieldLock,
  BsCardText,
} from "react-icons/bs";
import { FiScissors } from "react-icons/fi";
import { HiOutlineTicket, HiBadgeCheck } from "react-icons/hi";
import { BiBadgeCheck } from "react-icons/bi";
import { ImMan } from "react-icons/im";
import { FaChild } from "react-icons/fa";

var QRCode = require("qrcode.react");

class Download extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      details: [],
      query: "",
      loadBarProgress: true,
      spinning: "none",
      updateDisplay: "block",
      numPages: null,
      pageNumber: 1,
      loadingText: true,
    };
  }

  componentDidMount() {
    const businessname = localStorage.getItem("businessname");
    const accounttype = localStorage.getItem("accounttype");
    const businessid = localStorage.getItem("businessid");
    const eventid = localStorage.getItem("eventid");
    const eventname = localStorage.getItem("eventname");
    const reprint = this.props.location.state.reprint;
    document.title = "Ticket print - " + " " + eventname + " - " + businessname;
    // alert(eventid);
    Axios.get(
      "https://karamale.com/apps/kscanner/webservices.php?query=TICKETREADYTODOWNLOAD&eventid=" +
        eventid +
        "&reprint=" +
        reprint,
      {
        withCredentials: true,
      }
    )
      .then((response) => {
        if (response.data.length == 0) {
          this.setState({ details: [], loadBarProgress: false });
        } else {
          this.setState({
            details: response.data,
            loadBarProgress: false,
            loadingText: false,
          });
          window.print();
        }
      })
      .catch((error) => console.log(error));

    setTimeout(() => {
      Axios.get(
        "https://karamale.com/apps/kscanner/webservices.php?query=ALLOCATETICKETS&businessid=" +
          businessid +
          "&eventid=" +
          eventid,
        {
          withCredentials: true,
        }
      )
        .then((response) => {
          if (response.data.val == 0) {
          } else {
          }
        })
        .catch((error) => console.log(error));
    }, 3000);
  }

  download = () => {
    window.print();
  };

  titleCase = (str) =>
    str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

  details = () => {
    let activeString = "";
    const accountid = localStorage.getItem("businessid");
    const businessname = localStorage.getItem("businessname");
    const accounttype = localStorage.getItem("accounttype");
    let ticketnumber = "";
    const { loadingText } = this.state;

    let ticketCount = 1;
    const pageSize = 4;
    const groupedTickets = [];
    for (let i = 0; i < this.state.details.length; i += pageSize) {
      groupedTickets.push(this.state.details.slice(i, i + pageSize));
    }

    // const ref = React.createRef();
    return (
      <div className={"text-center"}>
        {loadingText && (
          <div className="text-center w-100 mt-5 small-details">
            <ClipLoader size={40} color={"#8d949e"} />
            <br />
            Fetching tickets...
          </div>
        )}
        {this.state.details.length <= 0 ? (
          <div className="mt-3 pl-3 pr-3">
            <label
              style={{
                width: "100%",
                textAlign: "center",
                fontSize: 15.5,
                color: "#5B7083",
              }}
            >
              It looks like the tickets you are trying to print have already
              been printed.
              <br />
              If this is not the case, please dial <span>
                +27 78 236 5403
              </span>{" "}
              for assistance.
              <br />
              <br />
              <Link to="/dashboard" className="color-blue">
                Dashboard
              </Link>
            </label>
          </div>
        ) : (
          groupedTickets.map((group, pageIndex) => (
            <div className="page" key={pageIndex}>
              {group.map((item, index) => {
                const numberCount = ticketCount;
                ticketCount++;
                return (
                  <>
                    <div
                      className="w-100"
                      style={{
                        padding: "5mm",
                        backgroundColor: "#e61d25",
                        // borderBottom: "thin solid white",
                      }}
                    >
                      <table
                        width={"100%"}
                        align={"center"}
                        cellpadding={0}
                        cellspacing={0}
                        style={{ fontFamily: "arial" }}
                        className="ticket"
                      >
                        <tr
                          style={{
                            background: "rgb(242, 242, 242, 0.9)",
                          }}
                        >
                          <th
                            rowspan={5}
                            style={{
                              color: "#333",
                              textAlign: "center",
                              fontWeight: 400,
                              fontSize: 15,
                              backgroundImage: `url(
                                                      "https://karamale.com/logok.png"
                                                    )`,
                              backgroundSize: "cover",
                              // border: "thin solid #f3f4f4",
                              paddingLeft: "15",
                              paddingRight: "15",
                              borderTopLeftRadius: 0,
                              borderBottomLeftRadius: 0,
                              borderTopRightRadius: 15,
                              borderBottomRightRadius: 15,
                            }}
                          >
                            <label
                              style={{
                                fontSize: 15,
                                marginTop: 13,
                                padding: 8,
                                paddingLeft: 10,
                                paddingRight: 10,
                                border: "thin solid #e61d25",
                                backgroundColor: "transparent",
                                color: "#e61d25",
                                borderRadius: 100,
                              }}
                            >
                              Event dates
                            </label>
                            <br />
                            <label style={{ marginTop: 10 }}>
                              {item.eventdate}{" "}
                              <span style={{ fontWeight: 400 }}>
                                {item.eventmonth}, {item.eventyear}
                              </span>
                            </label>
                            <br />

                            <table
                              width={"100%"}
                              style={{
                                fontSize: 17,
                                marginTop: 0,
                                padding: 10,
                                textAlign: "center",
                                border: "hidden",
                              }}
                              cellspacing={0}
                              cellpadding={0}
                              border={0}
                            >
                              <tr
                                style={{
                                  backgroundColor: "transparent",
                                }}
                              >
                                <td
                                  width={"25%"}
                                  style={{
                                    fontSize: 14,
                                    fontWeight: 400,
                                    paddingBottom: 0,
                                    backgroundColor: "transparent",
                                  }}
                                  cellspacing={0}
                                  cellpadding={0}
                                >
                                  <b>Time:</b>{" "}
                                  <label
                                    className="mb-0"
                                    style={{ color: "grey" }}
                                  >
                                    {item.starttime} - {item.finishtime}
                                  </label>
                                </td>
                              </tr>
                              <tr
                                style={{
                                  border: "hidden",
                                  backgroundColor: "transparent",
                                }}
                              >
                                <td
                                  style={{
                                    fontSize: 14,
                                    fontWeight: 400,
                                    border: "hidden",

                                    overflowWrap: "break-word",
                                    wordWrap: "break-word",
                                    width: "10%",
                                  }}
                                >
                                  <b>Venue:</b>
                                  <br />
                                  <label
                                    style={{
                                      color: "grey",
                                      paddingTop: 5,
                                      fontWeight: 400,
                                    }}
                                  >
                                    {item.venue.split(",").join("\r\n")}
                                  </label>
                                </td>
                              </tr>
                            </table>

                            <table
                              align={"center"}
                              style={{
                                width: "100%",
                                marginTop: 15,
                                borderRadius: 100,
                                color: "#fff",
                                padding: 10,
                              }}
                            >
                              <tr
                                style={{
                                  backgroundColor: "transparent",
                                }}
                              >
                                <td
                                  style={{
                                    borderTop: "thin solid #dcdcdc",
                                    textAlign: "center",
                                    marginTop: 15,
                                    paddingTop: 15,
                                    border: "hidden",
                                  }}
                                >
                                  <b
                                    style={{
                                      color: "#e61d25",
                                      fontSize: 13,
                                      fontWeight: 400,
                                    }}
                                  >
                                    Powered by
                                  </b>
                                  <br />
                                  <img
                                    src="https://karamale.com/malelogo.png"
                                    width={100}
                                    style={{
                                      marginBottom: 5,
                                      marginTop: 5,
                                    }}
                                  />
                                  <br />
                                  <label
                                    style={{
                                      color: "#e61d25",
                                      marginTop: 3,
                                      fontSize: 12,
                                      fontWeight: 400,
                                    }}
                                  >
                                    Hosting an event?
                                    <br />
                                    <b style={{ color: "#e61d25" }}>
                                      WhatsApp:
                                    </b>{" "}
                                    +27 78 236 5403
                                  </label>
                                </td>
                              </tr>
                            </table>
                          </th>

                          <th
                            colspan={2}
                            width={"60%"}
                            style={{
                              borderBottom: "thin solid #fff",
                              background: "#e61d25",
                              fontSize: 20,
                              color: "#fff",
                              textAlign: "center",
                              padding: 10,
                              paddingTop: 10,
                              paddingBottom: 10,
                            }}
                          >
                            {this.titleCase(localStorage.getItem("eventname"))}
                            <br />
                            <span
                              style={{
                                fontWeight: 400,
                                color: "#fff",
                                fontSize: 15,
                              }}
                            >
                              Hosted by {item.organiserName || businessname}
                            </span>
                          </th>

                          <th
                            style={{
                              background: "#e61d25",
                              borderLeft: "thin dashed #fff",
                              borderBottom: "thin solid #fff",
                              textAlign: "center",
                            }}
                          >
                            <label
                              style={{
                                padding: 5,
                                paddingTop: 5,
                                paddingBottom: 5,
                                background: "#fff",
                                color: "#e61d25",
                                textAlign: "center",
                                fontSize: 12,
                                fontWeight: 500,
                                borderRadius: 5,
                                borderBottom: "thin solid yellow",
                              }}
                            >
                              {numberCount}
                            </label>
                          </th>
                        </tr>

                        <tr
                          style={{
                            background: "#e61d25",
                            textAlign: "center",
                            fontSize: 13,
                          }}
                        >
                          <td
                            style={{
                              padding: 0,
                              borderBottom: "thin solid #fff",
                              color: "#fff",
                              paddingBottom: 10,
                              paddingTop: 10,
                            }}
                          >
                            <b>Customer details</b>
                          </td>
                          <td
                            style={{
                              padding: 0,
                              borderBottom: "thin solid #fff",
                              borderLeft: "thin solid #fff",
                              color: "#fff",
                            }}
                          >
                            <b> Cost details</b>
                          </td>

                          <td
                            rowSpan={4}
                            width={"15%"}
                            style={{
                              padding: 0,
                              borderLeft: "thin dashed #fff",
                              borderTop: "thin solid #fff",
                              borderRight: "hidden",
                              textAlign: "center",
                              color: "#fff",
                              fontSize: 13,
                              paddingLeft: 20,
                              paddingRight: 20,
                            }}
                          >
                            <label className="mb-0 mt-3 font-size-12 color-white">
                              Scan Here
                            </label>
                            <br />
                            <div
                              className="mt-2 mb-2"
                              style={{
                                justifyContent: "center",
                                padding: "10px",
                                backgroundColor: "#fff",
                                display: "inline-block",
                                borderRadius: "8px",
                              }}
                            >
                              <QRCode
                                value={item.qr_payload}
                                logoSize={0}
                                size={140}
                                // quietZone={10}
                              />
                            </div>
                            <br />
                            {item.ticketnumber}
                            <br />
                            <label
                              style={{
                                color: "#e61d25",
                                fontWeight: 400,
                                background: "#ffffff",
                                borderRadius: 100,
                                padding: 5,
                                paddingLeft: 10,
                                paddingRight: 10,
                                fontSize: 12,
                                marginTop: 5,
                              }}
                            >
                              {item.age_group == 1 ? <>Child</> : <>Adult</>}
                            </label>
                          </td>
                        </tr>
                        <tr style={{ background: "#e61d25" }}>
                          <td
                            style={{
                              padding: 0,
                              borderBottom: "thin solid #fff",
                              textAlign: "center",
                              fontSize: 13,
                              paddingLeft: 20,
                              paddingRight: 20,
                              paddingTop: 10,
                              paddingBottom: 10,
                            }}
                          >
                            <span style={{ color: "#fff" }}>Issued to:</span>{" "}
                            <span
                              style={{
                                fontWeight: 400,
                                color: "#fff",
                              }}
                            >
                              Customer
                            </span>
                            <br />
                            <br />
                            <span style={{ color: "#fff" }}>
                              Ticket holder:
                            </span>{" "}
                            <span
                              style={{
                                fontWeight: 400,
                                color: "#fff",
                              }}
                            >
                              Customer
                            </span>
                          </td>

                          <td
                            style={{
                              padding: 0,
                              borderBottom: "thin solid #fff",
                              borderRight: "thin dashed #fff",
                              borderLeft: "thin solid #fff",
                              color: "#fff",
                              textAlign: "center",
                              fontSize: 13,
                              paddingLeft: 30,
                              paddingRight: 30,
                            }}
                          >
                            <span style={{ color: "#fff" }}>Ticket price:</span>{" "}
                            <span
                              style={{
                                fontWeight: 400,
                                color: "#fff",
                              }}
                            >
                              R
                              {parseInt(item.age_group) == 1
                                ? Number(item.kids_price).toFixed(2)
                                : Number(item.price).toFixed(2)}
                            </span>
                            <br />
                            <br />
                            <span style={{ color: "#fff" }}>Total:</span>{" "}
                            <span
                              style={{
                                fontWeight: 400,
                                color: "#fff",
                              }}
                            >
                              R
                              {parseInt(item.age_group) == 1
                                ? Number(item.kids_price).toFixed(2)
                                : Number(item.price).toFixed(2)}
                            </span>
                          </td>
                        </tr>

                        <tr
                          style={{
                            background: "#e61d25",
                            textAlign: "center",
                            fontSize: 13,
                          }}
                        >
                          <td
                            style={{
                              color: "#fff",
                              borderBottom: "thin solid #fff",
                            }}
                          >
                            <span>Type: </span>{" "}
                            {item.category == "vip"
                              ? "VIP"
                              : item.category == "vvip"
                              ? "VVIP"
                              : "General"}
                            <br />
                            <b style={{ color: "#fff" }}>Admission:</b> 1
                          </td>
                          <td
                            style={{
                              color: "#fff",
                              borderRight: "thin dashed #fff",
                              borderLeft: "thin solid #fff",
                              borderBottom: "thin solid #fff",
                            }}
                          >
                            <span>Organiser's email</span>
                            <br />
                            {item.organiser_email}
                          </td>
                        </tr>
                        <tr
                          style={{
                            background: "#e61d25",
                            textAlign: "center",
                            fontSize: 13,
                          }}
                        >
                          <td
                            style={{
                              color: "#fff",
                            }}
                          >
                            <b style={{ color: "#fff" }}>Security Notice</b>
                            <br /> Do not share this ticket publicly
                          </td>
                          <td
                            style={{
                              color: "#fff",
                              borderRight: "thin dashed #fff",
                              borderLeft: "thin solid #fff",
                            }}
                          >
                            <span>Signature</span>
                            <br />
                            {item.qr_payload.split(".")[1].slice(0, 8)}
                          </td>
                        </tr>
                      </table>
                    </div>
                  </>
                );
              })}
            </div>
          ))
        )}
      </div>
    );
  };

  onDocumentLoadSuccess({ numPages }) {
    this.setState({ numPages: numPages });
    // setNumPages(numPages);
  }

  render() {
    if (localStorage.getItem("businessid") === null) {
      return <Redirect to="/login" />;
      //   return exit(1),
    } else {
    }
    const { loadBarProgress } = this.state;

    return (
      <div className="view p-0" style={{ backgroundColor: "#fff" }}>
        <div className="row justify-content-center just-container-insid">
          <div className="col-lg-12 p-0">{this.details()}</div>
        </div>

        {/* <Footer /> */}
      </div>
    );
  }
}

export default Download;
